function HexToHSB(hex: string) {
  hex = hex.replace(/^#/, '');
  hex = hex.length === 3 ? hex.replace(/(.)/g, '$1$1') : hex;

  var red = parseInt(hex.substring(0, 2), 16) / 255,
    green = parseInt(hex.substring(2, 4), 16) / 255,
    blue = parseInt(hex.substring(4, 6), 16) / 255;

  var cMax = Math.max(red, green, blue),
    cMin = Math.min(red, green, blue),
    delta = cMax - cMin,
    saturation = cMax ? delta / cMax : 0;

  switch (cMax) {
    case 0:
      return [0, 0, 0];
    case cMin:
      return [0, 0, cMax];
    case red:
      return [60 * (((green - blue) / delta) % 6) || 0, saturation, cMax];
    case green:
      return [60 * ((blue - red) / delta + 2) || 0, saturation, cMax];
    case blue:
      return [60 * ((red - green) / delta + 4) || 0, saturation, cMax];
    default:
      return [0, 0, 0];
  }
}


export let avatarDefaultBackgroundColors: Record<string, string> = {
  sussie: '#d996fa',
  smokeStack: '#a73e05',
  elphaba: '#679933',
  galinda: '#ffa9e7',
  godzilla: '#f97a66',
  weirdBarbie: '#fe5bdf',
  evelynWang: '#f7ab56',
  chani: '#eb7e09',
  AVATAR_9: '#ffa9e7',
  neytiri: '#124f95',
  paleMan: '#5c1e1e',
  nemo: '#6d60a6',
  jackSparrow: '#5fb0b7',
  AVATAR_4: '#CC3333',
  legolas: '#677861',
  AVATAR_5: '#edd382',
  AVATAR_10: '#9999ff',
  ironGiant: '#6666cc',
  AVATAR_3: '#b7eea6',
  jackieBrown: '#6679f2',
  AVATAR_7: '#CCCC00',
  leia: '#33CCFF',
  AVATAR_1: '#FFCC33',
  AVATAR_0: '#FF9933',
  blacula: '#114547',
  AVATAR_8: '#FF6699',
  AVATAR_2: '#c287e8',
  AVATAR_6: '#5bc9af',
  moon: '#16092e',
};

export let avatarColors = [
  '#ffa9e7',
  '#cf125a',
  '#efb9cb',
  '#ff6799',
  '#dd7696',
  '#cc3333',
  '#ed6a5a',
  '#d6b9b2',
  '#a73d05',
  '#f7c59f',
  '#f2a257',
  '#ff9a34',
  '#eb7e09',
  '#694e32',
  '#c0b299',
  '#ffcc33',
  '#edd382',
  '#cccd02',
  '#72b11e',
  '#679933',
  '#869e7b',
  '#677761',
  '#b7eea6',
  '#bbe2c3',
  '#a7cdbd',
  '#5bc9af',
  '#bcf8ec',
  '#59c3c3',
  '#104547',
  '#5fb0b7',
  '#33ccff',
  '#124f95',
  '#afd3e9',
  '#9fa0c3',
  '#9999ff',
  '#6666cc',
  '#cc99ff',
  '#673399',
  '#c287e8',
  '#e6aded',
  '#d996fa',
  '#16092e',
  '#2c67c9',
].sort((a, b) => {
  let hsva = HexToHSB(a);
  let hsvb = HexToHSB(b);
  return hsva[0] - hsvb[0];
});